import * as React from "react";
type Props = {
  className?: string,
};
function SvgSaveTime({ className }: Props) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-SaveTime"
      className={className}
    >
      <path
        d="M23.7599 42.24C32.6406 42.24 39.8399 35.0407 39.8399 26.16C39.8399 17.2792 32.6406 10.08 23.7599 10.08C14.8792 10.08 7.67993 17.2792 7.67993 26.16C7.67993 35.0407 14.8792 42.24 23.7599 42.24Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M23.1986 35.4617L23.04 28.112"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M23.887 23.1921C22.4034 22.7946 20.8785 23.675 20.481 25.1585C20.0834 26.6421 20.9639 28.167 22.4474 28.5645C23.931 28.962 25.4559 28.0816 25.8534 26.5981C26.2509 25.1145 25.3705 23.5896 23.887 23.1921Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M25.6667 25.0358L36.152 24.8094"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M33.6001 37.9199L36.9601 43.7396"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8869 16.3555C40.1276 15.8732 40.2619 15.3393 40.2738 14.7901C40.295 13.813 39.9272 12.8675 39.2514 12.1616C38.5755 11.4557 37.6468 11.0472 36.6698 11.026C36.1123 11.0139 35.5651 11.1284 35.0668 11.3546C33.9767 10.5244 32.8396 9.81822 31.6799 9.23969C33.0674 7.99426 34.8794 7.32058 36.7494 7.3612C38.6984 7.40353 40.5508 8.21839 41.899 9.62651C43.2473 11.0346 43.981 12.9207 43.9386 14.8697C43.8984 16.7228 43.1598 18.4885 41.877 19.8166C41.3406 18.6369 40.6763 17.4751 39.8869 16.3555Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.05175 15.8756C7.81106 15.3932 7.67677 14.8593 7.66484 14.3101C7.64362 13.333 8.01141 12.3876 8.6873 11.6816C9.36319 10.9757 10.2918 10.5672 11.2689 10.546C11.8264 10.5339 12.3735 10.6484 12.8718 10.8746C13.9619 10.0445 15.0991 9.33824 16.2587 8.75971C14.8712 7.51428 13.0592 6.8406 11.1893 6.88122C9.24025 6.92355 7.38785 7.73841 6.0396 9.14652C4.69136 10.5546 3.9577 12.4407 4.00003 14.3897C4.04028 16.2428 4.77885 18.0085 6.06168 19.3367C6.59808 18.157 7.26233 16.9951 8.05175 15.8756Z"
        fill="currentColor"
      />
      <path
        d="M13.9201 37.9199L10.5601 43.7396"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
export default SvgSaveTime;
